import { EActivityType } from '@constants';
import { useTranslation } from 'react-i18next';

import { ActivityTypeWrapper, NameWrapper, CardsWrapper } from './ActivityTypeSelector.styles';

import { Icon } from '@/components/Icon';
import { ACTIVITY_ICONS } from '@/constants';
import { useProfile } from '@/store';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
};

const ICON_SIZE = 24;

export const ActivityTypeSelector: React.FC<Props> = ({ value, onChange }) => {
  const {
    roleCheck: { isManager }
  } = useProfile();
  const options = Object.values(EActivityType);

  const { t } = useTranslation('CourseTranslations');

  const isSelected = (option: string) => value === option;

  const handleChange = (option: string) => {
    if (!isManager && value) return;
    onChange && onChange(option);
  };

  return (
    <CardsWrapper>
      {options.map(option => (
        <ActivityTypeWrapper
          key={option}
          onClick={() => handleChange(option)}
          className={isSelected(option) ? 'selected' : undefined}>
          <Icon i={ACTIVITY_ICONS[option]} size={ICON_SIZE} />
          <NameWrapper>{t(option)}</NameWrapper>
        </ActivityTypeWrapper>
      ))}
    </CardsWrapper>
  );
};
